// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"32":"HomeView","86":"CoursesView","132":"PolicyView","372":"CourseView","373":"RulesView","705":"ContactsView","741":"PaymentSecure"}[chunkId] + "." + {"32":"211e05ae","86":"4c1609de","132":"64c0f9d9","372":"0260b12c","373":"4f42edbf","705":"a55358a9","741":"c552bd64"}[chunkId] + ".css";
};